import { Typography } from "@mui/material";
import { CreateSupportTicketMetaRouting } from "../../../app/backendTypes";

export default function SupportRoutingDisplay(props: {
  routing: CreateSupportTicketMetaRouting;
}) {
  const { routing } = props;

  return (
    <>
      <Typography>
        <Typography component="span" color="text.secondary">
          Type:{" "}
        </Typography>
        {routing.jiraRequestType}
      </Typography>

      <Typography>
        <Typography component="span" color="text.secondary">
          Description:{" "}
        </Typography>
        {routing.description}
      </Typography>
    </>
  );
}
